// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — control-plate.styled.classic.js, новая — control-plate.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './control-plate.styled.classic';
import * as cp from './control-plate.styled.cp';

export const Limiter = isCp ? cp.Limiter : classic.Limiter;
export const LimiterItem = isCp ? cp.LimiterItem : classic.LimiterItem;
export const NumberBox = isCp ? cp.NumberBox : undefined;
export const ToggleWrapper = isCp ? cp.ToggleWrapper : classic.ToggleWrapper;
